<template>
  <div class="company-select">
    <multiselect
      v-model="selectedCompany"
      label="name"
      track-by="id"
      :placeholder="placeholder"
      :options="companyOptions"
      :loading="companyLoading"
      :searchable="true"
      :internal-search="false"
      :allow-empty="true"
      :show-labels="false"
      :class="{ 'border-active': selectedCompany !== null }"
      @search-change="onCompanySearch"
      @input="onCompanyInput"
      @open="fetchCompanies('')"
    >
      <span
        slot="afterList"
        v-observe-visibility="onCompanyVisibilityChanged"
      />
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { ObserveVisibility } from "vue-observe-visibility";
import axios from "axios";

export default {
    name: "CompanyMultiselect",
    components: { Multiselect },
    directives: { ObserveVisibility },
    props: {
        companiesUrl: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: "All companies",
        },
    },
    data() {
        return {
            selectedCompany: null,
            companyOptions: [],
            companyLoading: false,
            companySearchTimer: null,
            companyPage: 1,
            hasMoreCompanies: false,
            companyCurrentSearch: "",
        };
    },
    beforeDestroy() {
        window.clearTimeout(this.companySearchTimer);
    },
    methods: {
        fetchCompanies(search, append = false) {
            if (!append) {
                this.companyPage = 1;
                this.companyOptions = [];
            }
            this.companyLoading = true;
            this.companyCurrentSearch = search;
            axios.get(this.companiesUrl, {
                params: { search, limit: 50, page: this.companyPage },
            })
                .then(({ data }) => {
                    this.companyOptions = [...this.companyOptions, ...data.data];
                    this.hasMoreCompanies = data.meta.has_more;
                })
                .finally(() => { this.companyLoading = false; });
        },
        onCompanySearch(query) {
            window.clearTimeout(this.companySearchTimer);
            this.companySearchTimer = window.setTimeout(() => this.fetchCompanies(query), 300);
        },
        onCompanyVisibilityChanged(isVisible) {
            if (isVisible && !this.companyLoading && this.hasMoreCompanies) {
                this.companyPage += 1;
                this.fetchCompanies(this.companyCurrentSearch, true);
            }
        },
        onCompanyInput(company) {
            this.$emit("input", company);
        },
        reset() {
            this.selectedCompany = null;
            this.companyOptions = [];
            this.companyPage = 1;
            this.hasMoreCompanies = false;
            this.companyCurrentSearch = "";
        },
    },
};
</script>

<style scoped>
.company-select >>> .multiselect {
    min-height: 38px;
    font-size: 0.875rem;
}

.company-select >>> .multiselect__tags {
    min-height: 38px;
    padding-top: 6px;
    border-radius: 0.375rem;
    border-color: #dee2e6;
}

.company-select >>> .multiselect__single {
    font-size: 0.875rem;
    margin-bottom: 0;
    padding-top: 2px;
}

.company-select >>> .multiselect__placeholder {
    font-size: 0.875rem;
    margin-bottom: 0;
    padding-top: 2px;
}

.company-select >>> .multiselect.border-active .multiselect__tags {
    border-color: #153c4a !important;
}
</style>
